import styled from 'styled-components';

export const PickerHeading = styled.div`
  color: #17181a;

  font-size: 18px;
  line-height: 22px;
  font-weight: 700;

  padding: 0 4px;
`;
